// extracted by mini-css-extract-plugin
export default {"body":"body--e6d90264","sidebar":"sidebar--d62a5a43","content":"content--a2a9de5d","copyright":"copyright--279849bd","mask":"mask--b1370af8","open":"open--798448dd"};